export default __webpack_public_path__ + "static/media/TechStack.afcf5884.PNG";